import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65dafb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-info-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InstalledDetail = _resolveComponent("InstalledDetail")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InstalledDetail, {
      class: "installed-detail",
      clientInfo: { device_id: _ctx.deviceId },
      "is-terminal-info": ""
    }, null, 8, ["clientInfo"])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}